import { callApiWithoutToken } from './api';

import { UpdateHealthRequest } from '@/types/attendanceRecord';

export const updateLineAttendanceRecordHealth = async (
  lineAccessToken: string,
  reservationID: number,
  input: UpdateHealthRequest
) => {
  const { status, result } = await callApiWithoutToken<boolean>(
    `line/attendance-records/${reservationID}/health`,
    'PATCH',
    lineAccessToken,
    undefined,
    input
  );
  return { status, result };
};
